export default "__VITE_ASSET__OLh2IzON__"